import { ArrowDown } from './Icons';
import useInstaller from '../hooks/useInstaller';

export default function DownloadButton({ className = '', short = false, onClick }) {
  const installer = useInstaller();
  const classes = ['btn', 'btn--arrow', 'btn--download', className].filter(Boolean).join(' ');
  const label = installer.href
    ? (short ? 'Download' : installer.button)
    : (installer.ready ? (short ? 'Coming soon' : installer.pendingLabel) : (short ? 'Download' : installer.button));

  if (!installer.href) {
    return (
      <button type="button" className={classes} disabled onClick={onClick}>
        {label}
        <ArrowDown />
      </button>
    );
  }

  return (
    <a className={classes} href={installer.href} download={installer.name} onClick={onClick}>
      {label}
      <ArrowDown />
    </a>
  );
}
